import { createRoutine } from 'redux-saga-routines';

export const fetchGuestSummaryReport = createRoutine(
  'FETCH_INVENTORY_GUEST_SUMMARY_REPORT'
);
